// import React from 'react'

// const Followups = () => {
//   return (
//     <div>
//       Followups
//     </div>
//   )
// }

// export default Followups


import React, { useState } from 'react';
import { Plus, Search, Filter, Clock, CheckCircle, AlertCircle } from 'lucide-react';

const followupData = [
  { id: 'FU-001', customer: 'Acme Corp', contact: 'John Smith', type: 'Sales Call', dueDate: '2024-12-26', priority: 'High', status: 'Pending', notes: 'Discuss contract renewal' },
  { id: 'FU-002', customer: 'TechStart Inc', contact: 'Lisa Anderson', type: 'Email', dueDate: '2024-12-27', priority: 'Medium', status: 'Completed', notes: 'Send product catalog' },
  { id: 'FU-003', customer: 'Global Inc', contact: 'Mark Wilson', type: 'Meeting', dueDate: '2024-12-25', priority: 'High', status: 'Overdue', notes: 'Q1 planning session' },
  { id: 'FU-004', customer: 'Digital Pro', contact: 'Sarah Lee', type: 'Phone Call', dueDate: '2024-12-28', priority: 'Low', status: 'Pending', notes: 'Follow up on quote' },
  { id: 'FU-005', customer: 'Creative Agency', contact: 'Tom Brown', type: 'Demo', dueDate: '2024-12-29', priority: 'Medium', status: 'Scheduled', notes: 'Product demonstration' },
];

// Structural Clean Dashboard Inline UI Tokens Matrix
const styles = {
  container: { maxWidth: '1280px', margin: '0 auto', fontFamily: 'system-ui, -apple-system, sans-serif', backgroundColor: '#f9fafb', color: '#111827', boxSizing: 'border-box' },
  headerSection: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '16px', marginBottom: '24px' },
  title: { fontSize: '26px', fontWeight: '900', letterSpacing: '-0.5px', margin: '0 0 4px 0', color: '#111827' },
  subtitle: { fontSize: '14px', color: '#6b7280', margin: 0 },
  btnPri: { display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', border: 'none', borderRadius: '8px', backgroundColor: '#2563eb', color: '#ffffff', fontSize: '14px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)', transition: 'all 0.2s', justifyContent: 'center' },
  
  // Stats Block System
  statsGrid: { display: 'grid', gap: '16px', marginBottom: '24px' },
  statsCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' },
  statsLabel: { color: '#6b7280', fontSize: '13px', margin: '0 0 4px 0', fontWeight: '500' },
  statsValue: (color = '#111827') => ({ fontSize: '26px', fontWeight: '900', color: color, margin: 0 }),

  // Filtering Controls Group
  filterCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', gap: '12px', boxSizing: 'border-box' },
  searchWrapper: { position: 'relative', flex: 1 },
  searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '18px', height: '18px', color: '#9ca3af' },
  searchInput: { width: '100%', padding: '10px 12px 10px 38px', fontSize: '14px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', boxSizing: 'border-box' },
  btnSec: { display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', border: '1px solid #e5e7eb', borderRadius: '8px', backgroundColor: '#f3f4f6', color: '#374151', fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s' },

  // Followup Grid Streams
  cardsGrid: { display: 'grid', gap: '20px' },
  entityCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)', display: 'flex', flexDirection: 'column', gap: '14px', boxSizing: 'border-box', transition: 'box-shadow 0.2s' },
  entityHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' },
  customerTitle: { fontSize: '16px', fontWeight: '700', color: '#111827', margin: 0 },
  priorityBadge: (priority) => {
    let bg = '#dbeafe', text = '#1e40af';
    if (priority === 'High') { bg = '#fee2e2'; text = '#991b1b'; }
    else if (priority === 'Medium') { bg = '#ffedd5'; text = '#9a3412'; }
    return { padding: '2px 8px', borderRadius: '9999px', fontSize: '11px', fontWeight: '700', backgroundColor: bg, color: text };
  },
  statusBadge: (status) => {
    let bg = '#f3f4f6', text = '#4b5563';
    if (status === 'Completed') { bg = '#d1fae5'; text = '#065f46'; }
    else if (status === 'Overdue') { bg = '#fee2e2'; text = '#991b1b'; }
    else if (status === 'Scheduled') { bg = '#dbeafe'; text = '#1e40af'; }
    else if (status === 'Pending') { bg = '#ffedd5'; text = '#9a3412'; }
    return { padding: '4px 12px', borderRadius: '9999px', fontSize: '11px', fontWeight: '800', backgroundColor: bg, color: text, textTransform: 'uppercase' };
  },

  // Item Details Rows
  infoStack: { display: 'flex', flexDirection: 'column', gap: '8px' },
  infoRow: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#374151' },
  notesBlock: { backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', padding: '12px', borderRadius: '8px', margin: 0 },
  notesText: { fontSize: '13px', color: '#4b5563', margin: 0, lineHeight: '1.5' },

  // Card Controls Group
  actionRow: { display: 'flex', gap: '8px', marginTop: '4px' }
};

const Followups = () => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filtering behaviors engine logic 
  const filteredFollowups = followupData.filter(item => 
    item.customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.notes.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={styles.container}>
      {/* Component Structural Layout Media Fluidity Injector */}
      <style>{`
        .fu-top-header { flex-direction: column; align-items: flex-start; }
        .fu-top-header button { width: 100%; }
        .fu-stats-responsive { grid-template-columns: repeat(2, 1fr); }
        .fu-filter-bar { flex-direction: column; }
        .fu-cards-responsive { grid-template-columns: 1fr; }

        @media (min-width: 576px) {
          .fu-top-header { flex-direction: row; align-items: center; justify-content: space-between; }
          .fu-top-header button { width: auto; }
          .fu-filter-bar { flex-direction: row; }
        }
        @media (min-width: 992px) {
          .fu-stats-responsive { grid-template-columns: repeat(4, 1fr); }
          .fu-cards-responsive { grid-template-columns: repeat(2, 1fr); }
        }
      `}</style>

      {/* Top Header Section */}
      <div className="fu-top-header" style={styles.headerSection}>
        <div>
          <h1 style={styles.title}>Follow-ups</h1>
          <p style={styles.subtitle}>Track customer follow-ups and tasks</p>
        </div>
        <button style={styles.btnPri}>
          <Plus style={{ width: '18px', height: '18px' }} />
          <span>Add Follow-up</span>
        </button>
      </div>

      {/* Stats Board Metrics Panel */}
      <div className="fu-stats-responsive" style={styles.statsGrid}>
        <div style={styles.statsCard}>
          <p style={styles.statsLabel}>Total Follow-ups</p>
          <h3 style={styles.statsValue('#111827')}>124</h3>
        </div>
        <div style={styles.statsCard}>
          <p style={styles.statsLabel}>Pending</p>
          <h3 style={styles.statsValue('#ea580c')}>45</h3>
        </div>
        <div style={styles.statsCard}>
          <p style={styles.statsLabel}>Overdue</p>
          <h3 style={styles.statsValue('#dc2626')}>8</h3>
        </div>
        <div style={styles.statsCard}>
          <p style={styles.statsLabel}>Completed</p>
          <h3 style={styles.statsValue('#16a34a')}>71</h3>
        </div>
      </div>

      {/* Filters Form Control Element */}
      <div style={styles.filterCard}>
        <div className="fu-filter-bar" style={{ display: 'flex', gap: '12px', width: '100%' }}>
          <div style={styles.searchWrapper}>
            <Search style={styles.searchIcon} />
            <input
              type="text"
              placeholder="Search follow-ups..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
            />
          </div>
          <button style={styles.btnSec}>
            <Filter style={{ width: '16px', height: '16px' }} />
            <span>Filter</span>
          </button>
        </div>
      </div>

      {/* Follow-ups Cards Pipeline Stream Grid */}
      <div className="fu-cards-responsive" style={styles.cardsGrid}>
        {filteredFollowups.map((followup) => (
          <div key={followup.id} style={styles.entityCard}>
            <div style={styles.entityHeader}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                  <h3 style={styles.customerTitle}>{followup.customer}</h3>
                  <span style={styles.priorityBadge(followup.priority)}>
                    {followup.priority}
                  </span>
                </div>
                <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontFamily: 'monospace' }}>{followup.id}</p>
              </div>
              <span style={styles.statusBadge(followup.status)}>
                {followup.status}
              </span>
            </div>

            <div style={styles.infoStack}>
              <div style={styles.infoRow}>
                <span style={{ color: '#6b7280', fontWeight: '500' }}>Contact:</span>
                <span style={{ fontWeight: '600' }}>{followup.contact}</span>
              </div>
              <div style={styles.infoRow}>
                <span style={{ color: '#6b7280', fontWeight: '500' }}>Type:</span>
                <span>{followup.type}</span>
              </div>
              <div style={styles.infoRow}>
                <Clock style={{ width: '14px', height: '14px', color: '#9ca3af' }} />
                <span style={{ color: '#6b7280', fontWeight: '500' }}>Due:</span>
                <span style={{ fontWeight: '500', color: followup.status === 'Overdue' ? '#dc2626' : '#111827' }}>{followup.dueDate}</span>
              </div>
            </div>

            <div style={styles.notesBlock}>
              <p style={styles.notesText}>{followup.notes}</p>
            </div>

            <div style={styles.actionRow}>
              <button style={styles.btnPri}>
                <CheckCircle style={{ width: '16px', height: '16px' }} />
                <span>Mark Complete</span>
              </button>
              <button style={{ ...styles.btnSec, backgroundColor: '#ffffff' }}>
                Edit
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Followups;